import { toPlutusDataInvestUnitType, toPlutusDataOracle_Data } from '../conversions';
import { Convertible } from '../index.exports';
import { type Oracle_Data, type TokensForInvestUnitDatum } from '../types';
import { BaseTxRedeemer } from '../../Entities/index.exports';

export type SwapOfferPolicyRedeemer = SwapOfferPolicyRedeemerMintID | SwapOfferPolicyRedeemerBurnID;

export class SwapOfferPolicyRedeemerMintID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;
}

export class SwapOfferPolicyRedeemerBurnID extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;
}

export type SwapOfferValidatorRedeemer =
    | SwapOfferValidatorRedeemerUpdateStatus
    | SwapOfferValidatorRedeemerUpdateCommission
    | SwapOfferValidatorRedeemerUpdateSwapRestrictions
    | SwapOfferValidatorRedeemerUpdateMinADA
    | SwapOfferValidatorRedeemerDeposit
    | SwapOfferValidatorRedeemerWithdraw
    | SwapOfferValidatorRedeemerSwapFTxADA
    | SwapOfferValidatorRedeemerSwapADAxFT
    | SwapOfferValidatorRedeemerDelete
    | SwapOfferValidatorRedeemerEmergency;

export class SwapOfferValidatorRedeemerUpdateStatus extends BaseTxRedeemer {
    protected static _plutusDataIndex = 0;
    protected static _plutusDataIsSubType = true;
    
    @Convertible({ isForRedeemer: true })
    rusNewStatus!: number;
}

export class SwapOfferValidatorRedeemerUpdateCommission extends BaseTxRedeemer {
    protected static _plutusDataIndex = 1;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rucrNewCommissionRate!: bigint;
}

export class SwapOfferValidatorRedeemerUpdateSwapRestrictions extends BaseTxRedeemer {
    protected static _plutusDataIndex = 2;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rusrAllowSellFT!: number;

    @Convertible({ isForRedeemer: true })
    rusrAllowSellADA!: number;
}

export class SwapOfferValidatorRedeemerUpdateMinADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 3;
    protected static _plutusDataIsSubType = true;
}

export class SwapOfferValidatorRedeemerDeposit extends BaseTxRedeemer {
    protected static _plutusDataIndex = 4;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rdNewDeposit_FT!: bigint;

    @Convertible({ isForRedeemer: true })
    rdNewDeposit_ADA!: bigint;
}

export class SwapOfferValidatorRedeemerWithdraw extends BaseTxRedeemer {
    protected static _plutusDataIndex = 5;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rwNewWithdraw_FT!: bigint;

    @Convertible({ isForRedeemer: true })
    rwNewWithdraw_ADA!: bigint;
}

export class SwapOfferValidatorRedeemerSwapFTxADA extends BaseTxRedeemer {
    protected static _plutusDataIndex = 6;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rsfxaAmount_FT!: bigint;

    @Convertible({ isForRedeemer: true })
    rsfxaAmount_ADA!: bigint;

    @Convertible({ isForRedeemer: true })
    rsfxaCommission_ADA!: bigint;

    @Convertible({ isForRedeemer: true, toPlutusData: toPlutusDataOracle_Data })
    rsfxaOracle_Data!: Oracle_Data;

    @Convertible({ isForRedeemer: true })
    rsfxaOracle_Signature!: string;
}

export class SwapOfferValidatorRedeemerSwapADAxFT extends BaseTxRedeemer {
    protected static _plutusDataIndex = 7;
    protected static _plutusDataIsSubType = true;

    @Convertible({ isForRedeemer: true })
    rsaxfAmount_ADA!: bigint;

    @Convertible({ isForRedeemer: true })
    rsaxfAmount_FT!: bigint;

    @Convertible({ isForRedeemer: true })
    rsaxfCommission_FT!: bigint;

    @Convertible({ isForRedeemer: true, toPlutusData: toPlutusDataOracle_Data })
    rsaxfOracle_Data!: Oracle_Data;

    @Convertible({ isForRedeemer: true })
    rsaxfOracle_Signature!: string;
}

export class SwapOfferValidatorRedeemerDelete extends BaseTxRedeemer {
    protected static _plutusDataIndex = 8;
    protected static _plutusDataIsSubType = true;
}

export class SwapOfferValidatorRedeemerEmergency extends BaseTxRedeemer {
    protected static _plutusDataIndex = 9;
    protected static _plutusDataIsSubType = true;
}
